module.exports = __webpack_public_path__ + "static/media/background.c6e42083.jpg";